import AlertMini from './AlertMini'

export default AlertMini
